function SkeletonBar({ className = "" }: { className?: string }) {
  return <div className={`animate-pulse rounded-full bg-muted/30 ${className}`} />;
}

export function ExcelFilesSkeleton() {
  return (
    <div className="mx-auto flex w-full max-w-7xl flex-col gap-6">
      <header className="relative py-8">
        <div className="grid gap-6 lg:grid-cols-[minmax(0,1fr)_minmax(300px,420px)] lg:items-end">
          <div>
            <SkeletonBar className="h-3 w-32" />
            <SkeletonBar className="mt-4 h-12 w-72 sm:h-14" />
            <SkeletonBar className="mt-4 h-4 w-96 max-w-full" />
          </div>
          <div className="flex flex-col gap-4 lg:items-end">
            <div className="flex items-center gap-2">
              <SkeletonBar className="h-8 w-24 rounded-full" />
            </div>
            <div className="grid w-full grid-cols-3 gap-0 overflow-hidden rounded-2xl border border-border/40 bg-muted/20">
              {[0, 1, 2].map((i) => (
                <div key={i} className="min-w-0 border-r border-border/40 px-4 py-3 last:border-r-0">
                  <SkeletonBar className="h-2.5 w-16" />
                  <SkeletonBar className="mt-2 h-4 w-8" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </header>

      <div className="space-y-3">
        <div className="flex flex-wrap items-center gap-3">
          <SkeletonBar className="h-10 w-[200px] rounded-full" />
          <SkeletonBar className="h-8 w-36 rounded-full" />
        </div>
      </div>

      <div className="overflow-hidden rounded-2xl border border-border/40 bg-muted/20">
        <div className="px-5 py-4">
          <div className="grid grid-cols-[minmax(0,1fr)_minmax(0,0.5fr)_minmax(0,0.6fr)_minmax(0,0.6fr)_auto] items-center gap-4 border-b border-border/40 px-1 pb-3">
            {[0, 1, 2, 3, 4].map((i) => (
              <SkeletonBar key={i} className="h-2.5 w-16" />
            ))}
          </div>
          {Array.from({ length: 5 }, (_, row) => (
            <article key={row} className="grid grid-cols-[minmax(0,1fr)_minmax(0,0.5fr)_minmax(0,0.6fr)_minmax(0,0.6fr)_auto] items-center gap-4 border-b border-border/40 py-5 last:border-b-0">
              <SkeletonBar className="h-3.5 w-40" />
              <SkeletonBar className="h-5 w-12 rounded-full" />
              <div className="flex items-center gap-2">
                <SkeletonBar className="h-6 w-6 rounded-full" />
                <SkeletonBar className="h-3.5 w-20" />
              </div>
              <SkeletonBar className="h-3.5 w-24" />
              <div className="flex items-center gap-2 justify-end">
                <SkeletonBar className="h-3.5 w-5" />
                <SkeletonBar className="h-3.5 w-5" />
                <SkeletonBar className="h-3.5 w-5" />
              </div>
            </article>
          ))}
        </div>
      </div>

      <div className="flex items-center justify-between text-sm text-muted-foreground">
        <SkeletonBar className="h-4 w-20" />
        <div className="flex items-center gap-2">
          <SkeletonBar className="h-9 w-9 rounded-full" />
          <SkeletonBar className="h-8 w-8 rounded-full" />
          <SkeletonBar className="h-8 w-8 rounded-full" />
          <SkeletonBar className="h-9 w-9 rounded-full" />
        </div>
      </div>
    </div>
  );
}
